import styled from 'styled-components/native';
import { themes } from '../../design/colors';
import Constants from 'expo-constants';
import { Platform } from 'react-native';

export const Container = styled.View`
  flex: 1;
  background-color: ${themes.colors.black2};
  padding-top: ${Constants.statusBarHeight}px;
`;

export const Content = styled.KeyboardAvoidingView.attrs({
  behavior: Platform.OS === 'ios' ? 'padding' : 'height'
})`
  flex: 1;
  justify-content: center;
  padding: 16px 16px 0 16px;
`;

export const Image = styled.Image`
  align-self: center; 
  width: 350px;
  height: 35px;
  /* width: 100%; */
  margin-bottom: 100px;
`;

export const TextInput = styled.TextInput`
    padding: 13px;
      background-color: #fff;
      width: 90%;
      margin-top: 50px;
      border-radius: 5px;
`;

export const Button = styled.TouchableOpacity`
     background-color: #82BF18;
      margin-top: 20px;
      width: 90%;
      height: 45px;
      border-radius: 5px;
`;

export const Text = styled.Text`
     text-align: center;
      padding-top: 30px;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
`;

export const RecoveryPassword = styled.TouchableOpacity``;